export default {
  print: [],

  reportInfo: [],
  
  reportInfoLog: {},

  reportInfoDropDown: [],
};
